const overloading = {
  breakpointNames: ['sm', 'md', 'lg', 'xl', 'xxl'],
  breakpoints: [576, 768, 992, 1200, 1600]
}

const colors = {
  blackColor : '#252525',
  goldColor : '#d1ab6c',
  darkBlueColor : '#084d8f'
}

const variables = {
  familyBase: '"proxima-nova",sans-serif',
  familyHeader: '"bree-serif",serif',

  primaryColor: '#c20f2f',
  fontColor: colors.blackColor,
  bgColor: '#ebebeb',

  ...colors,
  ...overloading
}

export default variables;